export enum HomeRoutes {
    index = 'home-index',
    translate = 'translate',
    transcribe = 'transcribe',
    analyze = 'analyze'
}
